// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import downArrow from "../../assets/images/chevron-up-black.svg";
// import {
//   useAddSubscriptionMutation,
//   useGetSubscriptionStatusQuery,
//   useUnsubscribeMutation,
// } from "../../store/api/tradingApi";
// import { useGetUserProfileQuery } from "../../store/api/authApi";

// const SubscriptionModal = ({ text, classname, advisorId }) => {
//   const [open, setOpen] = useState(false);
//   const [addSubscription, { isLoading }] = useAddSubscriptionMutation();
//   const [unsubscribe, { isLoading: isUnsubscribing }] = useUnsubscribeMutation();

//   const { data: subscriptionStatus } = useGetSubscriptionStatusQuery();

//   const subscription = subscriptionStatus?.find(
//     (call) => call.advisorId === advisorId
//   );

//   const isExpired = subscription?.expiresAt
//     ? new Date(subscription.expiresAt) < new Date()
//     : false;

//   const isSubscribed = subscription && !isExpired;

//   const activeSubscriptionsCount =
//     subscriptionStatus?.filter((sub) => {
//       const subExpired = sub.expiresAt
//         ? new Date(sub.expiresAt) < new Date()
//         : false;
//       return !subExpired;
//     }).length || 0;

//   const hasReachedLimit = activeSubscriptionsCount >= 2 && !isSubscribed;

//   const formatExpiryDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   const handleSubscribe = async () => {
//     if (hasReachedLimit) {
//       alert(
//         "You have reached the maximum limit of 2 active subscriptions. Please unsubscribe from an existing advisor to subscribe to a new one."
//       );
//       return;
//     }

//     try {
//       await addSubscription(advisorId).unwrap();
//       alert("Subscription Successful! Your 1-month free trial has started.");
//       setOpen(false);
//     } catch (error) {
//       console.error("Subscription error:", error);

//       if (error?.status === 409 || error?.data?.message?.includes("already subscribed")) {
//         alert("You are already subscribed to this advisor.");
//         window.location.reload();
//         return;
//       }

//       alert(
//         error?.data?.message ||
//           error.message ||
//           "Failed to subscribe to advisor. Please try again."
//       );
//     }
//   };

//   const { data: userProfile } = useGetUserProfileQuery();

//   const { userId: reduxUserId } = useSelector((state) => state.auth);

//   let userId = reduxUserId || localStorage.getItem("userID") || localStorage.getItem("userId");

//   if (!userId && userProfile?.id) {
//     userId = userProfile.id;
//     localStorage.setItem("userID", userId);
//   }

//   const handleUnsubscribe = async () => {
//     console.log("Unsubscribing...", { advisorId, userId });

//     if (!advisorId || !userId) {
//       console.error("Missing ID details", { advisorId, userId });
//       alert("Subscription details not found. Please try logging in again.");
//       return;
//     }

//     const confirmed = window.confirm(
//       "Are you sure you want to unsubscribe from this advisor?"
//     );
//     if (!confirmed) return;

//     try {
//       await unsubscribe({ advisorId, userId }).unwrap();
//       alert("Unsubscribed successfully.");
//       setOpen(false);
//     } catch (error) {
//       console.error("Unsubscribe error:", error);
//       alert(
//         error?.data?.message ||
//           error.message ||
//           "Failed to unsubscribe. Please try again."
//       );
//     }
//   };

//   const getButtonConfig = () => {
//     if (isSubscribed)
//       return { text: "Following", bg: "bg-green-600", disabled: false };
//     if (hasReachedLimit)
//       return {
//         text: "Limit Reached (2/2)",
//         bg: "bg-gray-400",
//         disabled: true,
//       };
//     if (isExpired)
//       return {
//         text: "Expired - Resubscribe",
//         bg: "bg-red-500",
//         disabled: false,
//       };
//     return { text: text, bg: "bg-blue-600", disabled: false };
//   };

//   const buttonConfig = getButtonConfig();

//   return (
//     <>
//       <button
//         className={`${classname} ${buttonConfig.bg} text-white px-4 py-2 rounded-md`}
//         onClick={() => setOpen(true)}
//         disabled={buttonConfig.disabled}
//       >
//         {buttonConfig.text}
//       </button>

//       {open && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
//           <div className="bg-white rounded-lg w-full max-w-md p-6 relative">

//             <button
//               className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
//               onClick={() => setOpen(false)}
//             >
//               ✕
//             </button>

//             <h2 className="text-lg font-semibold mb-4">
//               {isExpired ? "Subscription Expired" : "Subscription Details"}
//             </h2>

//             {hasReachedLimit && (
//               <div className="bg-orange-50 border border-orange-200 text-orange-700 rounded-md p-3 mb-4">
//                 <p className="font-semibold">Subscription Limit Reached</p>
//                 <p className="text-gray-600 text-sm mt-1">
//                   You have {activeSubscriptionsCount} active subscriptions.
//                   Maximum allowed is 2. Please unsubscribe from an existing
//                   advisor to subscribe to a new one.
//                 </p>
//               </div>
//             )}

//             {isSubscribed && !isExpired && subscription?.expiresAt && (
//               <div className="bg-blue-50 border border-blue-200 text-blue-700 rounded-md p-3 mb-4">
//                 <p className="font-semibold">Active Subscription</p>
//                 <p className="text-gray-600 text-sm mt-1">
//                   Expires on: {formatExpiryDate(subscription.expiresAt)}
//                 </p>
//               </div>
//             )}
//             {isExpired && subscription?.expiresAt && (
//               <div className="bg-red-50 border border-red-200 text-red-700 rounded-md p-3 mb-4">
//                 <p className="font-semibold">Subscription Expired</p>
//                 <p className="text-gray-600 text-sm mt-1">
//                   Expired on: {formatExpiryDate(subscription.expiresAt)}
//                 </p>
//               </div>
//             )}

//             <div className="mb-6">
//               <span className="block text-gray-700 mb-1 font-medium">
//                 Plans
//               </span>
//               <div className="relative">
//                 <select
//                   className="w-full border border-gray-300 rounded-md p-2 appearance-none pr-8"
//                   disabled={isSubscribed && !isExpired}
//                   defaultValue="1"
//                 >
//                   <option value="1">1 Month Free Access</option>
//                 </select>
//                 <img
//                   src={downArrow}
//                   alt="dropdown"
//                   className="absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 pointer-events-none"
//                 />
//               </div>
//             </div>

//             <div className="flex justify-between items-center mb-6">
//               <span className="text-gray-700 font-medium">Total Price</span>
//               <span className="text-green-600 font-semibold">₹ 0.00</span>
//             </div>

//             <div className="space-y-3">
//               {isSubscribed && !isExpired ? (
//                 <>
//                   <button
//                     className="w-full py-3 rounded-md text-white font-semibold bg-green-600"
//                     disabled
//                   >
//                     Already Subscribed ✓
//                   </button>
//                   <button
//                     className="w-full py-3 rounded-md text-white font-semibold bg-red-500 hover:bg-red-600 transition-colors disabled:bg-red-300"
//                     onClick={handleUnsubscribe}
//                     disabled={isUnsubscribing}
//                   >
//                     {isUnsubscribing ? "Unsubscribing..." : "Unsubscribe"}
//                   </button>
//                 </>
//               ) : (
//                 <button
//                   className={`w-full py-3 rounded-md text-white font-semibold ${
//                     hasReachedLimit
//                       ? "bg-gray-400 cursor-not-allowed"
//                       : isExpired
//                       ? "bg-red-500"
//                       : "bg-brand-blue"
//                   }`}
//                   onClick={handleSubscribe}
//                   disabled={isLoading || hasReachedLimit}
//                 >
//                   {hasReachedLimit
//                     ? "Subscription Limit Reached (2/2)"
//                     : isExpired
//                     ? "Resubscribe"
//                     : "Activate Free Trial"}
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default SubscriptionModal;

import React, { useState } from "react";
import { useSelector } from "react-redux";
import downArrow from "../../assets/images/chevron-up-black.svg";
import {
  useAddSubscriptionMutation,
  useGetSubscriptionStatusQuery,
  useUnsubscribeMutation,
} from "../../store/api/tradingApi";
import { useGetUserProfileQuery } from "../../store/api/authApi";

const SubscriptionModal = ({ text, classname, advisorId }) => {
  const [open, setOpen] = useState(false);
  const [addSubscription, { isLoading }] = useAddSubscriptionMutation();
  const [unsubscribe, { isLoading: isUnsubscribing }] =
    useUnsubscribeMutation();

  const { data: subscriptionStatus, refetch } = useGetSubscriptionStatusQuery();

  const subscription = subscriptionStatus?.find(
    (call) =>
      String(call.advisorId).trim().toLowerCase() ===
      String(advisorId).trim().toLowerCase()
  );

  const isExpired = subscription?.expiresAt
    ? new Date(subscription.expiresAt) < new Date()
    : false;

  const isSubscribed = subscription && !isExpired;

  const activeSubscriptionsCount =
    subscriptionStatus?.filter((sub) => {
      const subExpired = sub.expiresAt
        ? new Date(sub.expiresAt) < new Date()
        : false;
      return !subExpired;
    }).length || 0;

  const hasReachedLimit = activeSubscriptionsCount >= 2 && !isSubscribed;

  const formatExpiryDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleSubscribe = async () => {

    if (hasReachedLimit) {
      alert(
        "You have reached the maximum limit of 2 active subscriptions. Please unsubscribe from an existing advisor to subscribe to a new one."
      );
      return;
    }

    try {
      const result = await addSubscription(advisorId).unwrap();
      await refetch();
      alert("Subscription Successful! Your 1-month free trial has started.");
      setOpen(false);
    } catch (error) {
      console.error("Subscription error details:", error);
      console.error("Error status:", error?.status);
      console.error("Error data:", error?.data);

      if (
        error?.status === 409 ||
        error?.data?.message?.includes("already subscribed")
      ) {
        alert("You are already subscribed to this advisor.");
        await refetch();
        setOpen(false);
        return;
      }

      const errorMessage =
        error?.data?.message ||
        error?.message ||
        "Failed to subscribe to advisor. Please try again.";
      console.error("Final error message:", errorMessage);
      alert(errorMessage);
    }
  };

  const { data: userProfile } = useGetUserProfileQuery();

  const { userId: reduxUserId } = useSelector((state) => state.auth);

  let userId =
    reduxUserId ||
    localStorage.getItem("userID") ||
    localStorage.getItem("userId");

  if (!userId && userProfile?.id) {
    userId = userProfile.id;
    localStorage.setItem("userID", userId);
  }

  const handleUnsubscribe = async () => {

    if (!advisorId || !userId) {
      console.error("Missing ID details", { advisorId, userId });
      alert("Subscription details not found. Please try logging in again.");
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to unsubscribe from this advisor?"
    );
    if (!confirmed) return;

    try {
      await unsubscribe({ advisorId, userId }).unwrap();
      await refetch();
      alert("Unsubscribed successfully.");
      setOpen(false);
    } catch (error) {
      console.error("Unsubscribe error:", error);

      if (
        error?.status === 404 ||
        error?.data?.message?.includes("not found")
      ) {
        await refetch();
        alert("Unsubscribed successfully.");
        setOpen(false);
        return;
      }

      alert(
        error?.data?.message ||
          error.message ||
          "Failed to unsubscribe. Please try again."
      );
    }
  };

  const getButtonConfig = () => {
    if (isSubscribed)
      return { text: "Following", bg: "bg-green-600", disabled: false };

    if (isExpired)
      return {
        text: "Expired - Resubscribe",
        bg: "bg-red-500",
        disabled: false,
      };
    return { text: text, bg: "bg-blue-600", disabled: false };
  };

  const buttonConfig = getButtonConfig();

  return (
    <>
      <button
        className={`${classname} ${buttonConfig.bg} text-white px-4 py-2 rounded-md`}
        onClick={() => setOpen(true)}
        disabled={buttonConfig.disabled}
      >
        {buttonConfig.text}
      </button>

      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg w-full max-w-md p-6 relative">
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
              onClick={() => setOpen(false)}
            >
              ✕
            </button>

            <h2 className="text-lg font-semibold mb-4">
              {isExpired ? "Subscription Expired" : "Subscription Details"}
            </h2>

            {isSubscribed && !isExpired && subscription?.expiresAt && (
              <div className="bg-blue-50 border border-blue-200 text-blue-700 rounded-md p-3 mb-4">
                <p className="font-semibold">Active Subscription</p>
                <p className="text-gray-600 text-sm mt-1">
                  Expires on: {formatExpiryDate(subscription.expiresAt)}
                </p>
              </div>
            )}
            {isExpired && subscription?.expiresAt && (
              <div className="bg-red-50 border border-red-200 text-red-700 rounded-md p-3 mb-4">
                <p className="font-semibold">Subscription Expired</p>
                <p className="text-gray-600 text-sm mt-1">
                  Expired on: {formatExpiryDate(subscription.expiresAt)}
                </p>
              </div>
            )}

            <div className="mb-6">
              <span className="block text-gray-700 mb-1 font-medium">
                Plans
              </span>
              <div className="relative">
                <select
                  className="w-full border border-gray-300 rounded-md p-2 appearance-none pr-8"
                  disabled={isSubscribed && !isExpired}
                  defaultValue="1"
                >
                  <option value="1">1 Month Free Access</option>
                </select>
                <img
                  src={downArrow}
                  alt="dropdown"
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 w-4 h-4 pointer-events-none"
                />
              </div>
            </div>

            <div className="flex justify-between items-center mb-6">
              <span className="text-gray-700 font-medium">Total Price</span>
              <span className="text-green-600 font-semibold">₹ 0.00</span>
            </div>

            <div className="space-y-3">
              {isSubscribed && !isExpired ? (
                <>
                  <button
                    className="w-full py-3 rounded-md text-white font-semibold bg-green-600"
                    disabled
                  >
                    Already Subscribed ✓
                  </button>
                  <button
                    className="w-full py-3 rounded-md text-white font-semibold bg-red-500 hover:bg-red-600 transition-colors disabled:bg-red-300"
                    onClick={handleUnsubscribe}
                    disabled={isUnsubscribing}
                  >
                    {isUnsubscribing ? "Unsubscribing..." : "Unsubscribe"}
                  </button>
                </>
              ) : (
                <button
                  className={`w-full py-3 rounded-md text-white font-semibold ${
                    isExpired ? "bg-red-500" : "bg-brand-blue"
                  }`}
                  onClick={handleSubscribe}
                  disabled={isLoading}
                >
                  {isExpired ? "Resubscribe" : "Activate Free Trial"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SubscriptionModal;
